//import React, { useState, useEffect } from "react";
import React, { Component, PureComponent } from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import { getStrokeColor, numberWithCommas } from "../utils";
import { chartColors } from "../../../../../lib/utils";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

class TimeSeries extends PureComponent {
    state = {};
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }
    componentDidUpdate(prevProps) {
        if (prevProps.currentChartType != this.props.prevProps) {
            this.props.legendClick(false);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.expandWidget !== this.props.expandWidget ||
            nextProps.currentChartType !== this.props.currentChartType ||
            nextProps.showLegend !== this.props.showLegend ||
            // nextProps.showLabel !== this.props.showLabel ||
            nextProps.showGridLines !== this.props.showGridLines
            //  nextProps.index !== this.props.index
        ) {
            return true;
        }

        return false;
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getPlatformName = (id) => {
        let a = this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id);

        return a ? a.name : null;
    };

    getPlatformShortName = (id) => {
        return this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id).short_name;
    };

    formatData = (data) => {
        return data;
    };
    getOptions = () => {
        let self = this;
        let data = this.formatData(this.props.dataProp[this.props.splineType]);
        let comparisionData = this.props.comparisionData && this.formatData(this.props.comparisionData[this.props.splineType]);
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        let cols = [];
        let comapreCols = [];
        let xVal = {
            x: this.props.dataProp.xs,
        };

        let xValComapare = {
            x: this.props.comparisionData && this.props.comparisionData.xs,
        };

        let interval = 0;
        for (let pltId in data) {
            let value = [];

            if (data[pltId].length && data[pltId].reduce((x, y) => x + y, 0) === 0) continue;

            if (pltId === "ALL") {
                data[pltId] &&
                    data[pltId].map((x, i) => {
                        value.push({ y: Math.floor(x), x: xVal.x[i] });
                    });
                cols.push({
                    name: "All",
                    data: value,
                });
                continue;
            }
            data[pltId] &&
                data[pltId].map((x, i) => {
                    value.push({ y: Math.floor(x), x: xVal.x[i] });
                });

            cols.push({
                name: this.getPlatformName(pltId),
                shortName: this.getPlatformShortName(pltId),
                data: value,
                percentage: this.getPlatformName(pltId).toUpperCase(),
            });
            interval++;
        }

        if (comparisionData) {
            for (let pltId in comparisionData) {
                let value = [];

                if (comparisionData[pltId].length && comparisionData[pltId].reduce((x, y) => x + y, 0) === 0) continue;
                if (pltId === "ALL") {
                    comparisionData[pltId] &&
                        comparisionData[pltId].map((x, i) => {
                            xValComapare.x[i] && value.push({ y: Math.floor(x), x: xValComapare.x[i] });
                        });
                    comapreCols.push({
                        name: "All",
                        data: value,
                    });
                    continue;
                }
                comparisionData[pltId] &&
                    comparisionData[pltId].map((x, i) => {
                        xValComapare.x[i] && value.push({ y: Math.floor(x), x: xValComapare.x[i] });
                    });

                comapreCols.push({
                    name: this.getPlatformName(pltId),
                    shortName: this.getPlatformShortName(pltId),
                    data: value,
                    percentage: this.getPlatformName(pltId).toUpperCase(),
                });
                interval++;
            }
        }

        // Comparision for Not Present data

        if (comparisionData) {
            let firstdataValue = cols[0]?.data;
            let firstcomparisiondataValue = comapreCols && comapreCols[0]?.data;
            let names = [...new Set([...cols.map((v) => v.name), ...comapreCols.map((v) => v.name)])];
            let f1;
            let f2;
            for (let name of names) {
                f1 = cols.find((v) => v.name === name);
                f2 = comapreCols.find((v) => v.name === name);

                if (!f1) {
                    f2 = JSON.parse(JSON.stringify(f2));
                    f2.data = firstdataValue ? JSON.parse(JSON.stringify(firstdataValue)) : [];
                    // f2.value = 0;
                    let arr = [];

                    for (let obj of f2.data) {
                        arr.push({ ...obj, y: 0, shortName: f2.shortName, percentage: f2.percentage });
                    }
                    f2.data = arr;

                    cols.push(JSON.parse(JSON.stringify(f2)));
                } else if (!f2) {
                    f1 = JSON.parse(JSON.stringify(f1));
                    f1.data = firstcomparisiondataValue ? JSON.parse(JSON.stringify(firstcomparisiondataValue)) : [];
                    // f1.value = 0;
                    let arr = [];

                    for (let obj of f1.data) {
                        arr.push({ ...obj, y: 0, shortName: f1.shortName, percentage: f1.percentage });
                    }
                    f1.data = arr;

                    comapreCols.push(JSON.parse(JSON.stringify(f1)));
                }
            }
        }

        //End of Not present data

        cols.map((d, i) => {
            if (d.name !== "All") {
                d.color = getStrokeColor(d.shortName);
            } else {
                d.visible = false;
                d.color = "#7A3E46";
            }
        });
        // let xx;

        if (this.props.comparisionData) {
            comapreCols.map((d, i) => {
                d.linkedTo = ":previous";
                // d.xAxis = 1;
                if (d.name !== "All") {
                    d.color = getStrokeColor(d.shortName) + "85";

                    d.visible = true;
                } else {
                    d.visible = false;

                    d.color = "#7A3E46" + "85";
                }
            });
        }

        let plotComaprisiondata;

        let plotComaprisiondataCondition = this.props.comparisionData && comapreCols[0].data.length >= cols[0].data.length;

        if (plotComaprisiondataCondition && cols) {
            plotComaprisiondata = JSON.parse(JSON.stringify(cols));

            comapreCols &&
                comapreCols.forEach((element, ind) => {
                    element.data.forEach((ele, index) => {
                        if (plotComaprisiondata[ind] && plotComaprisiondata[ind].data[index]) {
                            plotComaprisiondata[ind].data[index].originalX = plotComaprisiondata[ind].data[index].x;
                            plotComaprisiondata[ind].data[index].x = ele.x;
                        }
                    });
                });
        } else {
            if (this.props.comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(comapreCols));

                cols &&
                    cols.forEach((element, ind) => {
                        element.data.forEach((ele, index) => {
                            if (plotComaprisiondata[ind] && plotComaprisiondata[ind].data[index]) {
                                plotComaprisiondata[ind].data[index].originalX = plotComaprisiondata[ind].data[index].x;
                                plotComaprisiondata[ind].data[index].x = ele.x;
                            }
                        });
                    });
            }
        }

        var arrayCombined = [];
        if (this.props.comparisionData) {
            plotComaprisiondata = plotComaprisiondata.sort((a, b) => {
                if (a.name > b.name) return 1;
                else return -1;
            });
            cols = cols.sort((a, b) => {
                if (a.name > b.name) return 1;
                else return -1;
            });
            comapreCols = comapreCols.sort((a, b) => {
                if (a.name > b.name) return 1;
                else return -1;
            });

            if (plotComaprisiondataCondition) {
                plotComaprisiondata.forEach((element, ind) => {
                    let getName = comapreCols.findIndex((ele) => ele.name == element.name);

                    if (getName > -1) {
                        arrayCombined.push(plotComaprisiondata[ind]);
                        arrayCombined.push(comapreCols[getName]);
                    }
                });
            } else {
                plotComaprisiondata.forEach((element, ind) => {
                    let getName = cols.findIndex((ele) => ele.name == element.name);

                    if (getName > -1) {
                        arrayCombined.push(cols[getName]);
                        arrayCombined.push(plotComaprisiondata[ind]);
                    }
                });
            }
        }

        let serObj = this.props.comparisionData ? arrayCombined : cols;

        const optionsOverTime = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "datetime",
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },

            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            series: serObj,
            time: {
                timezoneOffset: tzo,
            },
            plotOptions: {
                series: {
                    events: {
                        legendItemClick: function () {
                            self.props.legendClick(true);
                        },
                    },
                    pointWidth: 10,
                    // dataLabels: {
                    //     enabled: this.props.showLabel,
                    // },

                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("85");
                            let secondColorPoint = this.points[0]?.color.endsWith("85");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }

                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }
                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };

    render() {
        return this.props.expandWidget ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        ) : (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default TimeSeries;
